export const GA_EVT_STD_PAGE_VIEW = 'page_view';
export const GA_EVT_STD_ADD_TO_CART = 'add_to_cart';
export const GA_EVT_STD_PURCHASE = 'purchase';
export const GA_EVT_COOKIES_ACCEPTED = 'cookies_accepted';
export const GA_EVT_COOKIES_DECLINED = 'cookies_declined';
export const GA_EVT_PROMO_CODE_ENTERED = 'promo_code_entered';
export const GA_EVT_SIGN_UP = 'sign_up';
export const GA_EVT_INITIATE_CHECKOUT = 'initiate_checkout';
export const GA_EVT_INITIATE_PURCHASE = 'initiate_purchase';
export const GA_EVT_COMPLETE_REGISTRATION = 'complete_registration';

export type GA_EVT = typeof GA_EVT_COOKIES_ACCEPTED
| typeof GA_EVT_COOKIES_DECLINED
| typeof GA_EVT_STD_PAGE_VIEW
| typeof GA_EVT_STD_ADD_TO_CART
| typeof GA_EVT_STD_PURCHASE
| typeof GA_EVT_PROMO_CODE_ENTERED
| typeof GA_EVT_SIGN_UP
| typeof GA_EVT_INITIATE_CHECKOUT
| typeof GA_EVT_INITIATE_PURCHASE
| typeof GA_EVT_COMPLETE_REGISTRATION;

// https://developers.facebook.com/docs/meta-pixel/reference
export const FB_EVT_CUSTOM_INITIATE_PURCHASE = 'InitiatePurchase';
export const FB_EVT_INITIATE_CHECKOUT = 'InitiateCheckout';
export const FB_EVT_ADD_TO_CART = 'AddToCart';
export const FB_EVT_PURCHASE = 'Purchase';
export const FB_EVT_SUBSCRIBE = 'Subscribe';
export const FB_EVT_SEARCH = 'Search';
export const FB_EVT_LEAD = 'Lead';
export const FB_EVT_COMPLETE_REGISTRATION = 'CompleteRegistration';
export const FB_EVT_VIEW_CONTENT = 'ViewContent';

export type FB_EVT = typeof FB_EVT_CUSTOM_INITIATE_PURCHASE
| typeof FB_EVT_INITIATE_CHECKOUT
| typeof FB_EVT_ADD_TO_CART
| typeof FB_EVT_PURCHASE
| typeof FB_EVT_SUBSCRIBE
| typeof FB_EVT_SEARCH
| typeof FB_EVT_LEAD
| typeof FB_EVT_COMPLETE_REGISTRATION
| typeof FB_EVT_VIEW_CONTENT;

// https://docs.barion.com/Barion_Pixel_API_reference
export const BARION_EVT_ADD_TO_CART = 'addToCart';
export const BARION_EVT_INITIATE_CHECKOUT = 'initiateCheckout';
export const BARION_EVT_INITIATE_PURCHASE = 'initiatePurchase';
export const BARION_EVT_PURCHASE = 'purchase';

export type BARION_EVT = typeof  BARION_EVT_ADD_TO_CART
| typeof BARION_EVT_INITIATE_CHECKOUT
| typeof BARION_EVT_INITIATE_PURCHASE
| typeof BARION_EVT_PURCHASE;